import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import PackageHeader from '../components/PackageHeader';
import BenefitModal from '../components/BenefitModal';

@inject('packageStore')
@observer
export default class PackageBenefit extends Component {
  componentWillMount() {
    this.setPackageInfo();
  }

  setPackageInfo() {
    const {
      packageStore: {
        setPackageInfo:setPackageInStore,
        setBenefitGroups:setBenefitGroupsInStore,
      },
      location,
    } = this.props;

    const pathname = location.pathname;
    const barcode = pathname.split('/')[2];

    setPackageInStore(barcode);
    setBenefitGroupsInStore(barcode);
  }

  getStateStyle = (state) => {
    let stateGroup = {
      stateClass: '',
      stateLabel: '',
    };

    switch (state) {
      case 'A':
        stateGroup.stateClass = 'txt-used';
        stateGroup.stateLabel = '사용완료';
        break;
      case 'AR':
        stateGroup.stateClass = 'txt-using';
        stateGroup.stateLabel = '사용중'; 
        break;
      case 'E':
        stateGroup.stateClass = 'txt-use';
        stateGroup.stateLabel = '미사용'; 
        break;
      default:
        stateGroup.stateClass = 'txt-disabled';
        stateGroup.stateLabel = '사용불가'; 
    }

    return stateGroup;
  }

  renderBenefitList = (benefitGroup, barcode, isUse) => {
    if (_.isEmpty(benefitGroup)) return;

    return _.map(benefitGroup, (benefit, index) => {
        const {
          seq,
          couponCode,
          couponName,
          useCount,
          totalCount,
        } = benefit;

        let state = 'E';
        if (useCount > 0 && useCount < totalCount) state = 'AR';
        if (useCount === totalCount) state = 'A';
        const stateGroup = this.getStateStyle(state);

        const couponModal = () => {
          const {
            packageStore: {
              controlModal,
            }
          } = this.props;
         
          controlModal(seq, couponCode);
        }

        if (isUse) {
          return (
            <button
              type="button"
              className="btn-package"
              onClick={couponModal}
              key={seq}
            >
              <span className="number-package">{index + 1}</span>
              <h3 className="name-coupon">{couponName}</h3>
              <span className={`txt-state ${stateGroup.stateClass}`}>{stateGroup.stateLabel}</span>
              <span className="txt-count">| ({useCount}/{totalCount})</span>
            </button>
          )
        } else {
          return (
            <div
              className="btn-package"
              key={seq}
            >
              <span className="number-package">{index + 1}</span>
              <h3 className="name-coupon">{couponName}</h3>
              <span className={`txt-state ${stateGroup.stateClass}`}>{stateGroup.stateLabel}</span>
              <span className="txt-count">| ({useCount}/{totalCount})</span>
            </div>
          )
        }
    });
  }

  render() {
    const {
      packageStore: {
        barcode,
        packageInfo,
        benefitGroups,
      },
    } = this.props;

    if (_.isEmpty(packageInfo)) return false;

    let avalibleList = [];
    let doneList = [];
    
    _.forEach(benefitGroups, (benefitGroup) => {
      if (benefitGroup.totalCount !== benefitGroup.useCount) avalibleList.push(benefitGroup);
      if (benefitGroup.totalCount === benefitGroup.useCount) doneList.push(benefitGroup);
    });

    return (
      <div className="App Package">
        <PackageHeader
          tab="benefit"
        />
        <div className="App-container fade">
          { benefitGroups.length === 0 ? 
            <div className="txt-empty">
              제공되는 혜택 이용권이 없습니다
            </div>
            : null}
          { avalibleList.length > 0 ? 
            <div className="group-packages">
              {this.renderBenefitList(avalibleList, barcode, true)}
            </div>
            : null}
          { doneList.length > 0 ? 
            <div className="group-packages packages-end">
              <h2 className="title-package">사용완료 이용권</h2>
              {this.renderBenefitList(doneList, barcode, false)}
            </div>
            : null}
        </div>
        <BenefitModal />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PackageBenefit.jsx